import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const TicketList = ({ tickets, onTicketSelect, onCreateTicket }) => {
  const getPriorityColor = (priority) => {
    const colors = {
      low: 'text-success bg-success/10',
      medium: 'text-warning bg-warning/10',
      high: 'text-error bg-error/10',
      urgent: 'text-error bg-error/20'
    };
    return colors[priority] || colors.medium;
  };

  const getStatusColor = (status) => {
    const colors = {
      open: 'text-primary bg-primary/10',
      in_progress: 'text-warning bg-warning/10',
      resolved: 'text-success bg-success/10',
      closed: 'text-muted-foreground bg-muted'
    };
    return colors[status] || colors.open;
  };

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  return (
    <div className="bg-card rounded-lg border border-border">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h2 className="text-lg font-semibold text-foreground">Support Tickets</h2>
        <Button
          variant="default"
          size="sm"
          onClick={onCreateTicket}
          iconName="Plus"
          iconPosition="left"
        >
          New Ticket
        </Button>
      </div>

      <div className="divide-y divide-border">
        {tickets.length === 0 ? (
          <div className="p-8 text-center">
            <Icon name="Ticket" size={48} className="text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-medium text-foreground mb-2">No tickets yet</h3>
            <p className="text-muted-foreground mb-4">
              Create your first support ticket to get help with your travel needs.
            </p>
            <Button variant="default" onClick={onCreateTicket}>
              Create Ticket
            </Button>
          </div>
        ) : (
          tickets.map((ticket) => (
            <div
              key={ticket.id}
              className="p-4 hover:bg-muted/50 cursor-pointer transition-colors"
              onClick={() => onTicketSelect(ticket)}
            >
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-medium text-foreground line-clamp-1">
                  {ticket.subject}
                </h3>
                <div className="flex items-center space-x-2 ml-4">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(ticket.priority)}`}>
                    {ticket.priority}
                  </span>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(ticket.status)}`}>
                    {ticket.status.replace('_', ' ')}
                  </span>
                </div>
              </div>

              <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                {ticket.description}
              </p>

              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <div className="flex items-center space-x-4">
                  <span>#{ticket.id}</span>
                  <span>{ticket.category}</span>
                  <span>Created: {formatDate(ticket.createdAt)}</span>
                </div>
                {ticket.lastReply && (
                  <span>Last reply: {formatDate(ticket.lastReply)}</span>
                )}
              </div>

              {ticket.hasUnreadReplies && (
                <div className="flex items-center space-x-1 mt-2">
                  <div className="w-2 h-2 bg-primary rounded-full" />
                  <span className="text-xs text-primary font-medium">New reply</span>
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default TicketList;